export default __webpack_public_path__ + "static/media/p-3-desktop.07bc946c.png";